import { memo } from 'react'

// import { FullCenterContent } from '@shared/ui/wrappers'

import { Wrapper, Content } from './ui'

const FCNotFound = () => (
  <>
    <title>Page is not found</title>

    <Wrapper>
      <Content />
    </Wrapper>
  </>
)

export const NotFoundPage = memo(FCNotFound)
